// extracted by mini-css-extract-plugin
export var container = "Container-module--container--1808d";
export var paddingVertical = "Container-module--paddingVertical--d7359";
export var whiteBG = "Container-module--whiteBG--5de0f";
export var grayBG = "Container-module--grayBG--cb626";
export var blackBG = "Container-module--blackBG--c92e9";
export var transparentBG = "Container-module--transparentBG--63e4e";
export var stairs = "Container-module--stairs--2fe0c";